const isPositiveNumber = (value) => (Array.isArray(value) ? false : Number.isFinite(value) && value > 0);

// noinspection JSUnusedGlobalSymbols
export default isPositiveNumber;
